
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
// import EventCarousel from './EventCarousel'
import { Link } from 'react-router-dom';

const OverEventTitleCards = (props) => {
    console.log('🔍 OverEventTitleCards rendering with props:', props);
    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => {
        console.log('🖼️ Opening flyer modal for:', props.title);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        console.log('❌ Closing flyer modal');
        setShowModal(false);
    };

    return (
        <>


            <div className="auto-container">

                <div className="centered" style={{ marginTop: '15px', position: 'relative' }}>

                    <h3> {props.title}  </h3>
                    <hr />
                    {props.lablename === 'Register Now' ? (
                        <a href={props.links} style={{ color: 'darkblue !important' }} className="alert alert-primary">
                            <span className="btn-title"><span className="fa fa-2x fa fa-hand-o-right"></span>  Register Now</span>
                        </a>
                    ) : (
                        <a 
                            onClick={handleShowModal}
                            style={{ 
                                color: 'darkblue !important',
                                cursor: 'pointer',
                                textDecoration: 'none',
                                display: 'block'
                            }}
                            className="alert alert-primary"
                        >
                            <span className="btn-title"><span className="fa fa-2x fa fa-hand-o-right"></span>  View Flyer</span>
                        </a>
                    )}
                    <hr />
                </div>
            </div>

            <Row>

                <Col>

                    <div className="card card-margin">
                        <div className="card-header no-border">
                            <Link to={props.pagelinks}  > <h5 className="card-title"> {props.title} </h5></Link>

                        </div>
                        <div className="card-body pt-0">
                            <div className="widget-49">



                                <figure className="image" style={{ cursor: 'pointer' }} onClick={handleShowModal}>
                                    <img src={props.imgscr} alt={props.title} width="100%" />
                                    <a href={props.links} className="lightbox-image overlay" data-fancybox="gallery-two"></a>
                                </figure>
                                <br />
                                <div className="widget-49-meeting-action">
                                    <button 
                                        onClick={handleShowModal}
                                        className="btn btn-sm btn-flash-border-primary"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        View Flyer 
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>



                </Col>



            </Row >

            {/* Flyer Image Modal */}
            <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: 0 }}>
                    <img 
                        src={props.imglinks || props.imgscr} 
                        alt={props.title}
                        style={{ width: '100%', height: 'auto' }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <a 
                        href={props.imglinks || props.imgscr} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                        download
                    >
                        <i className="fa fa-download"></i> Download Flyer
                    </a>
                    <button className="btn btn-secondary" onClick={handleCloseModal}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>


            {/* 
            <section className="coming-events">

                <div className="auto-container">
                    <div className="sec-title centered">

                        <h2> Grand Janmashtami Schedules </h2>



                    </div>



                    <EventCarousel />


                </div>
            </section> */}


        </>


    )
}

export default OverEventTitleCards;

